/**
 * CognaraWordmark — text-rendered Cognara wordmark using the same Playfair
 * Display italic font as the master SVG logo. Used in places where the SVG
 * lockup would be too tall (sidenav header, marketing nav), so the brand
 * still reads consistently with the uploaded logo art.
 *
 * Props:
 *   • size: numeric pixel size for fontSize (default 18)
 *   • color: base text color (default 'currentColor')
 *   • emberG: whether to render the "g" in ember orange (default true)
 *   • className: extra classes
 */
export const CognaraWordmark = ({
  size = 18,
  color = 'currentColor',
  emberG = true,
  className = '',
  ...rest
}) => (
  <span
    className={className}
    style={{
      fontFamily: "'Playfair Display', Georgia, 'Times New Roman', serif",
      fontStyle: 'italic',
      fontWeight: 500,
      fontSize: size,
      lineHeight: 1,
      letterSpacing: '-0.005em',
      color,
      display: 'inline-block',
      whiteSpace: 'nowrap',
    }}
    aria-label="Cognara"
    {...rest}
  >
    Co<span style={emberG ? { color: '#F26B1F' } : undefined}>g</span>nara
  </span>
);

export default CognaraWordmark;
